// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"395":"3e5ab5c6","411":"b8342010","634":"06269c70","654":"6fb52b29","878":"4205c365"}[chunkId] + ".chunk.css";
};